import {createAction, props} from '@ngrx/store';
import {ApiConfig} from '@api/configs';

export const setConfig = createAction('[Config] set config', props<{ config: ApiConfig }>());
export const setConfigDefaultCountry = createAction('[Config] set default country', props<{ country: string }>());
export const setChangePriceGroupTo = createAction('[Config] set change priceGroup to', props<{ priceGroup?: string }>());

